module.exports = __webpack_public_path__ + "static/logo-b648ca3b1aabbe1cbf8793d2515f366e.png";